export default "__VITE_ASSET__LJSxwys9__"